var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"id-display grey lighten-4",attrs:{"src":_vm.imgSrc,"max-height":_vm.maxHeight,"contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }